import { CardBase, FlexContainer } from '@facephi/ui-react';
import styled from 'styled-components';

export const MapCard = styled(CardBase)`
  height: 35rem;
`;

export const MapContainer = styled(FlexContainer)`
  padding: 3.8rem 4rem;
`;
